// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  text-align: center;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 74px);
  background: var(--background);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.LoggedOut-homepage-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
  max-width: 500px;
}

.LoggedOut-logo-container {
  margin-bottom: 2rem;
  width: 100%;
}

.LoggedOut-flickswipe-logo {
  width: 80%;
  max-width: 300px;
  opacity: 0;
  animation: fadeInScale 1s forwards;
}

.LoggedOut-tagline-container {
  margin-bottom: 3rem;
  width: 100%;
}

.LoggedOut-tagline {
  font-size: 2.5rem;
  color: var(--theme-consistent);
  opacity: 0;
  animation: fadeIn 1s forwards;
  animation-delay: 0.5s;
}

.try-swiping-btn, .home-signup-link {
  padding: 15px 30px;
  font-size: 1.5rem;
  color: white;
  background-color: var(--theme-consistent);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  text-decoration: none;
  display: inline-block;
}

.try-swiping-btn:hover, .home-signup-link:hover {
  background-color: var(--secondary-theme);
  transform: scale(1.05);
}

.home-content {
  position: relative;
  height: 100%;
  width: 100%;
}

.home-signup-link {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes fadeInScale {
  0% { opacity: 0; transform: scale(0.9); }
  100% { opacity: 1; transform: scale(1); }
}

@media screen and (max-width: 600px) {
  .LoggedOut-tagline {
    font-size: 2rem;
  }

  .try-swiping-btn, .home-signup-link {
    font-size: 1.2rem;
    padding: 12px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/Home.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,KAAK,UAAU,EAAE,qBAAqB,EAAE;EACxC,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".home-container {\n  text-align: center;\n  height: 100vh;\n  position: relative;\n  overflow: hidden;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 74px);\n  background: var(--background);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.LoggedOut-homepage-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  width: 100%;\n  max-width: 500px;\n}\n\n.LoggedOut-logo-container {\n  margin-bottom: 2rem;\n  width: 100%;\n}\n\n.LoggedOut-flickswipe-logo {\n  width: 80%;\n  max-width: 300px;\n  opacity: 0;\n  animation: fadeInScale 1s forwards;\n}\n\n.LoggedOut-tagline-container {\n  margin-bottom: 3rem;\n  width: 100%;\n}\n\n.LoggedOut-tagline {\n  font-size: 2.5rem;\n  color: var(--theme-consistent);\n  opacity: 0;\n  animation: fadeIn 1s forwards;\n  animation-delay: 0.5s;\n}\n\n.try-swiping-btn, .home-signup-link {\n  padding: 15px 30px;\n  font-size: 1.5rem;\n  color: white;\n  background-color: var(--theme-consistent);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.try-swiping-btn:hover, .home-signup-link:hover {\n  background-color: var(--secondary-theme);\n  transform: scale(1.05);\n}\n\n.home-content {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.home-signup-link {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n}\n\n@keyframes fadeIn {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@keyframes fadeInScale {\n  0% { opacity: 0; transform: scale(0.9); }\n  100% { opacity: 1; transform: scale(1); }\n}\n\n@media screen and (max-width: 600px) {\n  .LoggedOut-tagline {\n    font-size: 2rem;\n  }\n\n  .try-swiping-btn, .home-signup-link {\n    font-size: 1.2rem;\n    padding: 12px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
